var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEbookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6367",
    "data-name": "Group 6367",
    transform: "translate(-57 -491.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6366",
    "data-name": "Group 6366",
    transform: "translate(57 492.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verified_black_24dp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6363",
    "data-name": "Group 6363"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1084",
    "data-name": "Rectangle 1084",
    width: 18,
    height: 18,
    transform: "translate(0 -0.1)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6365",
    "data-name": "Group 6365",
    transform: "translate(0.746 1.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6364",
    "data-name": "Group 6364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38774",
    "data-name": "Path 38774",
    d: "M17.415,9.327,15.595,7.245l.254-2.753L13.155,3.88,11.745,1.5,9.208,2.589,6.671,1.5,5.261,3.88l-2.694.6.254,2.761L1,9.327l1.821,2.082L2.567,14.17l2.694.612,1.41,2.388,2.537-1.1,2.537,1.089,1.41-2.38,2.694-.612-.254-2.753Zm-2.947,1.1-.418.485.06.634.134,1.455-1.418.321-.627.142-.328.552-.739,1.254L9.8,14.7l-.6-.254-.589.254-1.328.575-.739-1.246-.328-.552L5.6,13.334l-1.418-.321.134-1.462.06-.634-.418-.485-.963-1.1.963-1.1.418-.485L4.305,7.1,4.171,5.656l1.418-.321.627-.142.328-.552.739-1.254,1.328.575.6.254L9.8,3.962l1.328-.575.739,1.254.328.552.627.142,1.418.321L14.1,7.111l-.06.634.418.485.963,1.1Z",
    transform: "translate(-1 -1.5)",
    fill: "#048972"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_685",
    "data-name": "Ellipse 685",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(2 1.9)",
    fill: "#048972"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38775",
    "data-name": "Path 38775",
    d: "M9.125,12.257,7.394,10.519l-1.1,1.112,2.835,2.843L14.6,8.982,13.5,7.87Z",
    transform: "translate(55.403 490.001)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbookIcon);
export default __webpack_public_path__ + "static/media/ebookIcon.aac33592e38a1cbb2c67b67c52ce2add.svg";
export { ForwardRef as ReactComponent };